import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {ProtocolFindFascicoloRequest, ProtocolFindFascicoloResponse, ProtocolGetAllOriginResponse} from "../models/dto/protocol-fascicolo";
import {UtilityCommon} from "../../utils/utility-common";
import {ServicePathsSettings} from "../../../core/configuration/service-paths-settings";
import { RequestProtocol } from "../models/dto/request-fascicolo-protocol";

@Injectable({
  providedIn: 'root'
})
export class ProtocolService {

  constructor(
    private http: HttpClient
  ) {

  }

  public importProtocol(request: ProtocolFindFascicoloRequest) {
    return this.http
      .post<ProtocolFindFascicoloResponse>(
        ServicePathsSettings.DOMINIO + ServicePathsSettings.PROTOCOL_IMPORT_PATH, 
        request
      );
  }

  public getPreview(request: ProtocolFindFascicoloRequest) {
    return this.http
      .get<ProtocolFindFascicoloResponse>(
        UtilityCommon.toQueryParams(
          ServicePathsSettings.DOMINIO + ServicePathsSettings.PROTOCOL_PREVIEW_PATH,
          request
        )
      );
  }
  public postFascicolo(request: RequestProtocol) {
    return this.http
      .post<ProtocolFindFascicoloResponse>(
        ServicePathsSettings.DOMINIO + ServicePathsSettings.PROTOCOL_DOSSIERS_PATH,
          request
        )
  }

  public protocolDocument(request: RequestProtocol,idFascicolo:string) {
    return this.http
      .post<ProtocolFindFascicoloResponse>(
        ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_DOSSIER_DOCUMENT(idFascicolo),
          request
        )
  }

  public getAllOrigins() {
    return this.http
      .get<ProtocolGetAllOriginResponse>(
          ServicePathsSettings.DOMINIO + ServicePathsSettings.PROTOCOL_ORIGINS_PATH,
      );
  }
}
